import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { BusinessHoursDay } from "@msuite/utils/incoming-invoices";
import { client } from "@/hono";

export function useOrganizationSettings() {
	/** Query */
	const query = useQuery({
		queryKey: ["organization-settings"],
		queryFn: async () => {
			const response = await client.organizations.settings.$get();
			const data = await responseHandler(response);
			return data.organizationSettings;
		},
	});

	/** Computed */
	const businessHours = (query.data?.businessHours ?? null) as Array<BusinessHoursDay> | null;

	/** Return */
	return { ...query, organizationSettings: query.data, businessHours };
}
